import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionTagCreateInput } from '../generated/globalTypes';
import { createQuestionTagMutation, createQuestionTagMutationVariables } from '../generated/createQuestionTagMutation';
import { questionTagFieldsFragment } from '../models/QuestionTag';

/**
 * Get a callback to create a QuestionTag in the store.
 */
export function useCreateQuestionTagCallback(): [(model: QuestionTagCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createQuestionTagMutation, createQuestionTagMutationVariables>(
        gql`
            mutation createQuestionTagMutation ($model: QuestionTagCreateInput!) {
                createQuestionTag(model: $model) {
                    ...questionTagFields
                }
            }

            ${questionTagFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: QuestionTagCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
